// src/stone/icons/CentClock2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CentClock2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M17.334 26.667V20h2v6.667c0 .798.672 1.79 2.375 2.64 1.644.823 3.984 1.36 6.625 1.36s4.98-.537 6.624-1.36c1.703-.85 2.376-1.842 2.376-2.64V20h2v6.667c0 1.963-1.566 3.472-3.482 4.43-1.976.988-4.635 1.57-7.518 1.57s-5.543-.582-7.519-1.57c-1.916-.958-3.482-2.467-3.482-4.43" }),
      /* @__PURE__ */ jsx("path", { d: "M17.334 33.333v-6.666h2v6.666c0 .798.672 1.79 2.375 2.642 1.644.821 3.984 1.358 6.625 1.358s4.98-.537 6.624-1.358c1.703-.852 2.376-1.844 2.376-2.642v-6.666h2v6.666c0 1.964-1.566 3.472-3.482 4.43-1.976.988-4.635 1.57-7.518 1.57s-5.543-.582-7.519-1.57c-1.916-.958-3.482-2.466-3.482-4.43M21.71 17.359c-1.704.852-2.376 1.843-2.376 2.641s.672 1.79 2.376 2.641c1.643.822 3.984 1.359 6.624 1.359s4.98-.537 6.623-1.359c1.704-.852 2.377-1.843 2.377-2.641s-.673-1.79-2.377-2.641C33.314 16.537 30.973 16 28.334 16s-4.98.537-6.624 1.359m-.895-1.789c1.976-.988 4.636-1.57 7.518-1.57 2.884 0 5.543.582 7.519 1.57 1.916.958 3.482 2.467 3.482 4.43s-1.566 3.472-3.482 4.43c-1.976.988-4.635 1.57-7.518 1.57s-5.543-.582-7.519-1.57c-1.916-.958-3.482-2.466-3.482-4.43s1.566-3.472 3.482-4.43M14.334 7.333v7h-7v-2h5v-5z" }),
      /* @__PURE__ */ jsx("path", { d: "M13.333 2.667c-5.89 0-10.666 4.775-10.666 10.666S7.442 24 13.333 24h1v2h-1C6.338 26 .667 20.329.667 13.333S6.337.667 13.333.667c5.74 0 10.586 3.817 12.142 9.05l.285.958-1.917.57-.285-.958c-1.31-4.408-5.394-7.62-10.225-7.62" })
    ]
  }
);
var CentClock2X_default = CentClock2X;

export {
  CentClock2X,
  CentClock2X_default
};
